import { BaseInfoContext } from '@/context/BaseInfoContext';
import { Perms } from '@/models/perms';
import { IS_WECOM } from '@/utils/env';
import { Brand_Logo, getAdminAvatar } from '@/utils/uiHelper';
import { EyeOutlined, LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Modal from '@/components/Modal';
import { ThemeSwitch } from './ThemeSwitch';
import { useHeaderStyles } from './header.style';

export const AppHeader = ({
  collapsed,
  toggle,
  onChangePoiSelectModalVisible,
  onLogout,
}: {
  collapsed: boolean;
  toggle: () => void;
  onChangePoiSelectModalVisible: (visible: boolean) => void;
  onLogout: () => void;
}) => {
  const [baseInfo, , helpers] = useContext(BaseInfoContext);
  const { styles: headerStyle, cx } = useHeaderStyles();

  return (
    <div className={`${headerStyle.container}`}>
      <div className={headerStyle.left}>
        <div className={cx(headerStyle.logo, { collapsed })}>
          <Link to="/" className={headerStyle.logoInner}>
            <img src={Brand_Logo} draggable={false} alt={'logo'} />
            <span>veeyung</span>
          </Link>
        </div>

        {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
          className: headerStyle.menuToggleTrigger,
          onClick: toggle,
        })}

        {helpers.hasPermission(Perms.SYS_TENANT) && (
          <Tag
            color={'orange'}
            icon={<EyeOutlined />}
            onClick={() => {
              onChangePoiSelectModalVisible(true);
            }}>
            {baseInfo.poiName ? `商家视角: ${baseInfo.poiName}` : '使用商家视角'}
          </Tag>
        )}
      </div>
      <div className={headerStyle.login}>
        <ThemeSwitch />
        <Link to="/profile" className={headerStyle.user}>
          <span className={headerStyle.avatar}>
            {getAdminAvatar(baseInfo.avatar, baseInfo.assetsPrefix, { size: 32 })}
          </span>
          {baseInfo.nickName || baseInfo.userName}
        </Link>

        {!IS_WECOM && (
          <span
            className={headerStyle.logout}
            onClick={() => {
              Modal.confirm({
                title: '确认退出登录吗？',
                onOk: () => {
                  onLogout();
                },
              });
            }}>
            <LogoutOutlined /> 退出
          </span>
        )}
      </div>
    </div>
  );
};
